import React from 'react';
import { Modal, Form, Input, message, Button, Spin } from 'antd';
import { axiosInstance } from '../../util/Api';
import { BASE_API_CONFIG } from "../../util/Api";
import { useSelector } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';

const AddUserModel = ({ visible, onCancel, companyId, currentUserCount }) => {
  const [form] = Form.useForm();
  const authUser = useSelector(({ auth }) => auth.userData);
  const [submitting, setSubmitting] = React.useState(false); 

  console.log("authUser",authUser)
  const businessTypeId = authUser.businessTypeId;
  const companyName = authUser.companyName;
  const Subscription = authUser.Subscription;
  console.log("Subscription",Subscription)

  const id = authUser.id;
  console.log("id",id)
  const antIcon = <LoadingOutlined style={{ fontSize: 44 }} spin />;
  const uuid = authUser.uuid;
  console.log("uuid",uuid)

  // Set default password
  const DEFAULT_PASSWORD = "Welcome@123"; // You can change this to any default password

  // In your AddUserModel.jsx, update the handleSubmit function

const handleSubmit = async (values) => {
  setSubmitting(true);
  console.log("Form submitted with values:", values);

  try {
    if (currentUserCount >= 10) {
      message.error('User limit reached (max 10 users)');
      return;
    }

    const requestPayload = {
      email: values.email,
      password: DEFAULT_PASSWORD,
      requirePasswordChange: false, // CHANGE THIS TO false to indicate it's a secondary user
      uuid: authUser.uuid,
      id: authUser.id,
      businessTypeId: authUser.businessTypeId,
      companyName: authUser.companyName,
      gstNumber: authUser.gstNumber,
      port: Array.isArray(authUser.port) ? authUser.port : JSON.parse(authUser.port),
      loadingPort: authUser.loadingPort,
    };
    
    console.log("Request Payload:", requestPayload);

    const response = await axiosInstance.post(`${BASE_API_CONFIG.baseURL}/users/add`, requestPayload, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    console.log("Request response:", response);

    if (response.data.success) {
      message.success(`User added successfully! Welcome email sent to ${values.email}`);
      onCancel();
      form.resetFields();
    }
  } catch (error) {
    console.error("Error adding user:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
      console.error("Response status:", error.response.status);
    }
    message.error(error.response?.data?.message || 'Error adding user');
  } finally {
    setSubmitting(false);
  }
};

  return (
    <Modal
      title="Add User"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      closable={!submitting}
    >
      <Spin spinning={submitting} indicator={antIcon} tip="Adding user..." size="large">
        <Form form={form} onFinish={handleSubmit} layout="vertical" disabled={submitting}>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: 'Please input email!' },
              { type: 'email', message: 'Invalid email format' }
            ]}
          >
            <Input />
          </Form.Item>

          {/* Password field completely removed from UI */}

          <Form.Item>
            <Button type="default" onClick={onCancel}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" style={{ marginLeft: '8px' }}>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default AddUserModel;

